import React, { createContext, useContext, useEffect } from 'react';
import { ErrorPage } from 'modules/common/routes/ErrorPage';
import { GetMeQuery } from 'types/types';
import { getRequest } from 'utils/helper';

export const MeContext = createContext<any['me']>(null);

export const useMeContext = (): GetMeQuery['me'] => useContext(MeContext);

const getData = async () => {
  let data: any = null;
  try {
    const res = await getRequest(
      '/integration-settings-api/me-context',
      {},
      false
    );
    if (res.data) {
      data = res.data;
    }
  } catch (error: any) {
    return null;
  }
  return data;
};

const MeContextProvider: React.FunctionComponent = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const [data, setMeContextData] = React.useState<any>({});
  const getUserData = async () => {
    const response = await getData();
    setMeContextData(response);
  };
  useEffect(() => {
    getUserData();
  }, []);
  if (data === null) return <ErrorPage open={true} />;

  return <MeContext.Provider value={data?.me}>{children}</MeContext.Provider>;
};

export default MeContextProvider;
